export function money(cents: unknown, fallback = '价格待确认') {
  const value = Number(cents)
  return Number.isFinite(value) && value >= 0 ? `¥${Math.round(value / 100)}` : fallback
}

export function distance(value: unknown) {
  const metres = Number(value)
  if (!Number.isFinite(metres) || metres < 0) return ''
  return metres < 1000 ? `${Math.round(metres)}m` : `${(metres / 1000).toFixed(metres >= 10000 ? 0 : 1)}km`
}

export function dateLabel(date: unknown, start?: unknown, end?: unknown) {
  const raw = String(date || '')
  const parsed = new Date(`${raw}T00:00:00`)
  const day = Number.isFinite(parsed.getTime()) ? `${parsed.getMonth() + 1}月${parsed.getDate()}日` : raw
  const time = [start, end].filter(Boolean).map(String).join('–')
  return [day, time].filter(Boolean).join(' · ')
}

export function ntrpRange(min: unknown, max: unknown) {
  const lo = Number(min)
  const hi = Number(max)
  const hasLo = Number.isFinite(lo) && lo > 0
  const hasHi = Number.isFinite(hi) && hi > 0
  if (!hasLo && !hasHi) return '水平不限'
  if (hasLo && hasHi && lo === hi) return `${lo.toFixed(1)}`
  if (hasLo && hasHi) return `${lo.toFixed(1)}–${hi.toFixed(1)}`
  return hasLo ? `≥${lo.toFixed(1)}` : `≤${hi.toFixed(1)}`
}

export function statusText(status: unknown, date?: unknown, start?: unknown, end?: unknown) {
  if (Number(status) === 4) return '已取消'
  const now = Date.now()
  const startAt = new Date(`${String(date || '')}T${String(start || '00:00')}:00`).getTime()
  const endAt = new Date(`${String(date || '')}T${String(end || '23:59')}:00`).getTime()
  if (Number.isFinite(endAt) && now >= endAt) return '已结束'
  if (Number.isFinite(startAt) && now >= startAt) return '进行中'
  if (Number(status) === 1) return '已满员'
  return '报名中'
}
